import React from 'react';
import { useTranslation } from 'react-i18next';

import { useMytaverseEvent } from '@core/dashboard/providers';
import { useCommunications } from '@core/communications/providers/CommunicationsProvider';
import { ScreenShareIcon } from '@icons';
import HomeBarButton from '@core/dashboard/components/HomeBarButton';
import { useConference } from '@core/dashboard/components/DashboardContent/Dolby';
import useScreenShare from './hook/useScreenShare';
import { useClientSpecificDashboardButtonDisabled } from '@hooks/clientSpecificUtils';
import { DashboardButtonEnum } from '@constants/dashboard';

const ScreenShareButton = () => {
  const { t: translate } = useTranslation();

  const { ueScreenMediaStreams } = useConference();
  const { currentParticipant } = useMytaverseEvent();
  const handleShareScreenClick = useScreenShare();
  const { isSharingScreen, isInConference, isJoiningConference } =
    useCommunications();

  const isDisabledClientSpecific = useClientSpecificDashboardButtonDisabled(
    DashboardButtonEnum.SCREEN_SHARE_BUTTON,
  );

  const currentParticipantId = currentParticipant?.participantId || '';
  const currentScreenSharing = !!ueScreenMediaStreams.find(
    (s) => s.participantId === currentParticipantId,
  );

  const translatedShareTooltip =
    isSharingScreen && currentScreenSharing
      ? 'tooltips.stopShareScreen'
      : 'tooltips.shareScreen';

  return (
    <HomeBarButton
      label={translate(translatedShareTooltip)}
      isActive={isSharingScreen && currentScreenSharing}
      icon={<ScreenShareIcon />}
      isLoading={isJoiningConference}
      disabled={
        !isInConference ||
        (!!ueScreenMediaStreams.length && !currentScreenSharing) ||
        isDisabledClientSpecific
      }
      handleClick={handleShareScreenClick}
    />
  );
};

export default ScreenShareButton;
